import {gsap} from 'gsap';
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const tl = gsap.timeline({
      repeat: -1
    });
    const $carousel_items = document.querySelectorAll('.intro__content .carousel p');
    $carousel_items.forEach($p => {
      tl.to($p, {display: 'block', opacity: 1});
      const $spans = $p.querySelectorAll('span');
      $spans.forEach($span => {
        tl.from($span, {
          opacity: 0,
          y: '+=10px',
          onStart() {

          }
        });
      });
      tl.to($p, {opacity: 0, delay: .250});
      tl.to($p, {display: 'none', duration: 0});
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js